import { TranslationKeys } from "@/contexts/TranslationKeys";
import { getGlobalTranslator } from "@/services/utilities/ServiceError";

export const getTagTypes = () => {
    return {
        Slim: {
            value: '1',
            label: getGlobalTranslator().byKey(TranslationKeys.slimTag)
        },
        ISO_Animal: {
            value: '2',
            label: getGlobalTranslator().byKey(TranslationKeys.isoAnimal)
        },
        WriTag_2048: {
            value: '3',
            label: getGlobalTranslator().byKey(TranslationKeys.wriTag2048)
        },
        WriTag_128: {
            value: '4',
            label: getGlobalTranslator().byKey(TranslationKeys.wriTag128)
        },
        Ascii_Biometric_Magstripe: {
            value: '5',
            label: getGlobalTranslator().byKey(TranslationKeys.asciiBiometricMagstrip)
        },
        Personal_Access_Code: {
            value: '7',
            label: getGlobalTranslator().byKey(TranslationKeys.personalAccessCode)
        },
        RF_Infrared: {
            value: '8',
            label: getGlobalTranslator().byKey(TranslationKeys.rfInfraredTag)
        },
        Mifare: {
            value: '9',
            label: getGlobalTranslator().byKey(TranslationKeys.mifareTag)
        },
        HID: {
            value: '10',
            label: getGlobalTranslator().byKey(TranslationKeys.hidTag)
        },
        Vehicle_Registration_Plate: {
            value: '11',
            label: getGlobalTranslator().byKey(TranslationKeys.vehicleRegistrationPlate)
        },
        Felica: {
            value: '13',
            label: getGlobalTranslator().byKey(TranslationKeys.felicaTag)
        },
        General: {
            value: '14',
            label: getGlobalTranslator().byKey(TranslationKeys.general1356MHzTag)
        },
        Any: {
            value: '15',
            label: getGlobalTranslator().byKey(TranslationKeys.anyTagType)
        }
    }
};